// import axios from "axios";

// export const urls = {
//   users: "/api/users"
// };

export const cleanupUserData = () => {
  return localStorage.removeItem("userData");
};

export const setUserLocalData = (data) => {
  localStorage.setItem("userData", JSON.stringify(data));
};

export const getUserData = () => {
  return JSON.parse(localStorage.getItem("userData"));
};
